import ContentMessage from './content-message';
export default ContentMessage;
